@if ({
pricingGeoList: (pricingGeoList$ | async)
}; as vm) {
<div class="price-tiers p-4">
  <div class="page-heading mb-4 flex items-center justify-between">
    <div class="flex gap-4">
      <h3>Geolocations</h3>
      <a routerLink="./new">
        <button class="btn-blue">
          <svg-icon src="@assets/images/icons/plus.svg" class="btn-icon"></svg-icon>
          <span>Add Geolocation</span>
        </button>
      </a>
    </div>
    <div class="actions flex gap-4">
      <div class="relative">
        <button (click)="dropdown(1)" class="btn-neutral">
          <svg-icon src="@assets/images/icons/filter.svg" class="btn-icon"></svg-icon>
          <span>Filter</span>
        </button>
        <div [class]="isDropdown[1] ? '' : 'hidden'"
          class="absolute left-0 z-10 max-h-80 w-[226px] overflow-y-auto rounded border border-neutral-100 bg-white px-2.5 py-5 shadow-lg">
          <div class="flex flex-col">
            <div class="flex flex-col">
              <div class="input-check capitalize">
                <input type="checkbox" (change)="filterHandler($event)" [(ngModel)]="filterOptions.status"
                  class="form-check-input" id="formly_2_multicheckbox_status_0_0">
                <label class="form-check-label" for="formly_2_multicheckbox_status_0_0">{{ filterOptions.status ?
                  'Active' : 'Inactive'}}</label>
              </div>
            </div>
            <div class="flex gap-2.5 pt-4">
              <button (click)="clearFilter()" type="button" class="btn btn-outline-dark border-neutral-600">
                <span>Reset</span>
              </button>
              <button (click)="submitFilter()" class="btn btn-dark bg-neutral-600 text-white">
                <span>Filter</span>
              </button>
            </div>
          </div>
        </div>

      </div>
      <div class="input-group min-w-80">
        <div class="group">
          <svg-icon src="@assets/images/icons/search2.svg" class="input-icon"></svg-icon>
          <input (keyup.enter)="searchEvent($event)" [(ngModel)]="search"
            placeholder="Search by Id, Currency or Country name" />
        </div>
      </div>
    </div>
  </div>
  <ng-template #pricingGeoListPagination let-items>
    <div class="tier-list">
      <app-data-table title="Geolocation List" [badge]="pricingGeoList.length + ' Items'">
        <ng-container table>
          <table class="w-full text-left">
            <thead class="heading">
              <tr>
                <th scope="col" class="w-20">
                  <div class="col-name">ID</div>
                </th>
                <th scope="col" class="">
                  <div class="col-name">Currency</div>
                </th>
                <th scope="col" class="">
                  <div class="sortable">
                    <div class="col-name">Country</div>
                  </div>
                </th>
                <th scope="col" class="">
                  <div class="sortable">
                    <div class="col-name">Currency</div>
                  </div>
                </th>
                <th scope="col" class="w-28">
                  <div class="col-name">Status</div>
                </th>
                <th scope="col" class="w-28">
                  <div class="col-name">Option</div>
                </th>
              </tr>
            </thead>
            <tbody>
              @for (item of pricingGeoList; track item) {
              <tr class="text-left">
                <td class="">
                  <span class="course-id">{{ item.id }} </span>
                </td>
                <td>
                  <div class="flex max-w-[170px] items-center">
                    <a routerLink="./{{ item.id }}" class="course-name text-blue-600 underline">{{ item.currency_str }}
                    </a>
                  </div>
                </td>
                <td>
                  <span class="course-price">{{ item.country_str }} </span>
                </td>
                <td>
                  <span class="course-price">{{ item.currency_str }} </span>
                </td>
                <td>
                  @if (item.status) {
                  <div class="tag-green tag-sm">Active</div>
                  }
                  @if (!item.status) {
                  <div class="tag-red tag-sm">Inactive</div>
                  }
                </td>
                <td>
                  <div class="flex justify-center gap-2">
                    <a routerLink="./{{ item.id }}/edit">
                      <button class="btn-amber-soft btn-sm px-2">
                        <svg-icon src="@assets/images/icons/pencil.svg" class="btn-icon h-4 w-4"></svg-icon>
                      </button>
                    </a>
                    <button class="btn-outline-red btn-sm px-2" (click)="deleteConfirmation(item)">
                      <svg-icon src="@assets/images/icons/trash.svg" class="btn-icon h-4 w-4"></svg-icon>
                    </button>
                  </div>
                </td>
              </tr>
              }
            </tbody>
          </table>
        </ng-container>
      </app-data-table>
    </div>
  </ng-template>
  <!-- pagination  -->
  <div class="card-body">
    <div class="courses-list relative">
      @if (isLoading) {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
      }
      @if (vm.pricingGeoList?.results?.length === 0) {
      <span class="text-center text-2xl my-11 block">No items Founded!</span>
      } @else {
      <ng-container *ngTemplateOutlet="pricingGeoListPagination; context: { items: vm.pricingGeoList }">
      </ng-container>
      }
      <!-- Pagination -->
      <div class="z-30 relative">
        <app-common-pagination (paginatorData)="paginationAction($event)" (pageSize)="pageSizeAction($event)"
          [config]="paginationConfig" [type]="'dynamic'">
        </app-common-pagination>
      </div>
    </div>
  </div>
</div>
}

<!-- loader -->
<ng-template #loader>
  <div class="flex items-center justify-center w-full h-full left-0 right-0 absolute bg-[rgba(255,255,255,0.5)] z-20">
    <div class="loader">
      <svg class="text-blue-500 m-auto h-8 w-8 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none"
        viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
        </path>
      </svg>
    </div>
  </div>
</ng-template>